/**
 * UUID v4 generator that works in both secure and insecure browser contexts.
 *
 * `crypto.randomUUID()` is only available in secure contexts (HTTPS, localhost,
 * file://). That breaks Capacitor live-reload over plain HTTP from the Mac's
 * LAN IP (e.g. http://10.0.0.5:5173) — calls throw `TypeError: undefined is
 * not a function`. `crypto.getRandomValues()` is available everywhere, so we
 * fall back to it and assemble a v4 UUID per RFC 4122 §4.4.
 */
export function uuid(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
